import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getDiscounts = (params = {}) => api.get("/discounts", { params }).then((r) => r.data);
export const getFeatured = () => api.get("/discounts/featured").then((r) => r.data);
export const getDiscount = (id) => api.get(`/discounts/${id}`).then((r) => r.data);
export const createDiscount = (payload) => api.post("/discounts", payload).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);

export const adminList = (status) =>
    api.get("/admin/discounts", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdate = (id, status) =>
    api.patch(`/admin/discounts/${id}`, { status }).then((r) => r.data);
export const adminDelete = (id) => api.delete(`/admin/discounts/${id}`).then((r) => r.data);
